/**
 * @engine/input — Clamp Processor
 *
 * Clamps values to a specified range.
 */

import type { ProcessorType, ControlValue, ClampParams } from '../types';
import { InputProcessor, registerProcessor } from './InputProcessor';

/**
 * Clamp processor — limits values to min/max range
 */
export class ClampProcessor extends InputProcessor {
  readonly type: ProcessorType = 'clamp';

  private readonly min: number;
  private readonly max: number;

  constructor(params: Partial<ClampParams> = {}) {
    super(params as Record<string, unknown>);
    this.min = params.min ?? -1;
    this.max = params.max ?? 1;
  }

  process(value: ControlValue): ControlValue {
    if (typeof value === 'number') {
      return Math.max(this.min, Math.min(this.max, value));
    }

    if (this.isVec2(value)) {
      return {
        x: Math.max(this.min, Math.min(this.max, value.x)),
        y: Math.max(this.min, Math.min(this.max, value.y)),
      };
    }

    if (this.isVec3(value)) {
      return {
        x: Math.max(this.min, Math.min(this.max, value.x)),
        y: Math.max(this.min, Math.min(this.max, value.y)),
        z: Math.max(this.min, Math.min(this.max, value.z)),
      };
    }

    return value;
  }
}

registerProcessor('clamp', ClampProcessor);
